/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { FeatureRequestFullResponseDto } from '../models/feature-request-full-response-dto';
import { submitFeatureRequest } from '../fn/feature-request/submit-feature-request';
import { SubmitFeatureRequest$Params } from '../fn/feature-request/submit-feature-request';

@Injectable({ providedIn: 'root' })
export class FeatureRequestApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `submitFeatureRequest()` */
  static readonly SubmitFeatureRequestPath = '/api/v1/feature';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `submitFeatureRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  submitFeatureRequest$Response(params: SubmitFeatureRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<FeatureRequestFullResponseDto>> {
    return submitFeatureRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `submitFeatureRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  submitFeatureRequest(params: SubmitFeatureRequest$Params, context?: HttpContext): Observable<FeatureRequestFullResponseDto> {
    return this.submitFeatureRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<FeatureRequestFullResponseDto>): FeatureRequestFullResponseDto => r.body)
    );
  }

}
